<template lang="pug">
  .co-working
    h1(v-html='headline')
    .body.plans
      ul
        li(v-for='plan in plans')
          h3 {{plan.title}}
          span.price {{plan.price}}
          span.span {{plan.span}}
      a.cta(:href='"mailto:" + email') Jetzt Buchen

      p.info
        span(v-html='info')

    .clear
</template>

<script>
  export default {
    data () {
      return {
        title: 'Co-Working',
        indicator: require('@/assets/img/donauhof-co-working.svg'),
        image: require('@/assets/img/donauhof-co-working-image.jpg'),
        background: {
          rotate: -90,
          scale: {
            x: 3,
            y: 12
          },
          translate: {
            x: '-65%',
            y: '15%'
          }
        },
        headline: 'Zwischen neuen Arbeitswelten und altem Wiener Büro. Start November 2017.',
        plans: [
          {
            title: 'Dayticket',
            price: '15',
            span: 'Tag'
          },
          {
            title: 'Flex Desk ab',
            price: '160',
            span: 'Monat'
          },
          {
            title: 'Fix Desk ab',
            price: '240',
            span: 'Monat'
          }
        ],
        email: 'coworking@donauhofwien.at',
        info: 'alle Preise in Euro<br>und exklusive Mehrwertsteuer.'
      }
    },
    head () {
      return {
        title: this.title
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~utils";

  .co-working {
    text-align: center !important;
  }

  .plans {
    ul {
      margin: $gutter*2.5 0;
      @include tablet {
        margin: $gutter*5 0 $gutter*2.5;
      }
      li {
        width: 33.333%;
        display: inline-block;
        text-align: center;

        .price {
          @include sans;
          font-feature-settings: 'salt' 0;
          letter-spacing: 0.05em;
          color: $gold;
          font-size: 2rem;
          display: block;
          margin-top: .5rem;
        }
        .span {
          @include serif;
          font-size: .875rem;
          position: relative;
          margin-top: .25rem;
          padding-top: .5rem;
          display: block;
          &:before {
            @include pseudo;
            background: $black;
            height: 1px;
            width: 2rem;
            left: 0;
            right: 0;
            margin: auto;
          }
        }
      }
    }
    .cta {
      margin-top: $gutter;
    }
    p.info {
      display: block !important;
      margin-top: $gutter*5;
      line-height: 1 !important;
      @include large {
        margin-top: $gutter*2.5;
      }
      span {
        @include sans;
        font-size: .75rem;
        @include large {
          display: block;
          text-align: center;
        }
      }
      
    }
  }
</style>



// WEBPACK FOOTER //
// Co-Working.vue?c25651ee